import React from 'react';
import {
  UserCircleIcon,
  ChevronDownIcon,
  ShoppingCartIcon,
  MagnifyingGlassIcon,
  ArrowRightOnRectangleIcon,
  MapPinIcon,
  ClipboardDocumentListIcon,
  IdentificationIcon,
  HomeModernIcon,
  XMarkIcon,
  TruckIcon,
  CheckCircleIcon,
  ExclamationTriangleIcon,
  XCircleIcon,
  CreditCardIcon,
  DevicePhoneMobileIcon,
  BanknotesIcon,
  WalletIcon,
  ShoppingBagIcon,
  BuildingStorefrontIcon,
  Bars3Icon,
  ArrowLeftIcon,
  ArrowRightIcon,
  TrashIcon,
  PlusIcon,
  MinusIcon,
  StarIcon,
  HeartIcon,
  ShareIcon,
  PhoneIcon,
  EnvelopeIcon,
  ClockIcon,
  ShieldCheckIcon,
  LockClosedIcon,
  KeyIcon,
  ArrowPathIcon,
  ChevronRightIcon,
  HomeIcon,
  TagIcon,
  ReceiptPercentIcon,
  GlobeAltIcon,
  BuildingOfficeIcon,
  DocumentTextIcon,
  PrinterIcon,
} from '@heroicons/react/24/outline';

const base = { display: 'inline-block', flexShrink: 0 };

function withStyle(Icon) {
  return function IconWithStyle({ size = 20, style, ...props }) {
    return <Icon style={{ ...base, width: size, height: size, ...style }} {...props} />;
  };
}

export const Icons = {
  // Navigation & User
  User:        withStyle(UserCircleIcon),
  ChevronDown: withStyle(ChevronDownIcon),
  ChevronRight:withStyle(ChevronRightIcon),
  ArrowLeft:   withStyle(ArrowLeftIcon),
  ArrowRight:  withStyle(ArrowRightIcon),
  Menu:        withStyle(Bars3Icon),
  Home:        withStyle(HomeIcon),

  // Shopping
  Cart:        withStyle(ShoppingCartIcon),
  Bag:         withStyle(ShoppingBagIcon),
  Tag:         withStyle(TagIcon),
  Discount:    withStyle(ReceiptPercentIcon),
  Trash:       withStyle(TrashIcon),
  Plus:        withStyle(PlusIcon),
  Minus:       withStyle(MinusIcon),

  // Search & Actions
  Search:      withStyle(MagnifyingGlassIcon),
  Refresh:     withStyle(ArrowPathIcon),

  // Auth
  Logout:      withStyle(ArrowRightOnRectangleIcon),
  Lock:        withStyle(LockClosedIcon),
  Key:         withStyle(KeyIcon),
  Shield:      withStyle(ShieldCheckIcon),

  // Location & Delivery
  Location:    withStyle(MapPinIcon),
  Truck:       withStyle(TruckIcon),
  Globe:       withStyle(GlobeAltIcon),

  // User pages
  Orders:      withStyle(ClipboardDocumentListIcon),
  Profile:     withStyle(IdentificationIcon),
  Address:     withStyle(HomeModernIcon),
  Document:    withStyle(DocumentTextIcon),
  Print:       withStyle(PrinterIcon),

  // Status
  Success:     withStyle(CheckCircleIcon),
  Warning:     withStyle(ExclamationTriangleIcon),
  Error:       withStyle(XCircleIcon),
  Close:       withStyle(XMarkIcon),
  Star:        withStyle(StarIcon),
  Heart:       withStyle(HeartIcon),

  // Payment
  Card:        withStyle(CreditCardIcon),
  Mobile:      withStyle(DevicePhoneMobileIcon),
  Cash:        withStyle(BanknotesIcon),
  Wallet:      withStyle(WalletIcon),

  // Business
  Store:       withStyle(BuildingStorefrontIcon),
  Office:      withStyle(BuildingOfficeIcon),
  Phone:       withStyle(PhoneIcon),
  Email:       withStyle(EnvelopeIcon),
  Clock:       withStyle(ClockIcon),
  Share:       withStyle(ShareIcon),
};
